import { AppUtils } from "../util/app.utils";

export class OperationTaskImageModel {
    public id: number;
    public name: string;
    public data: string;
    public extension: string;
    public path: string;
    public url: string;

    constructor(entry: any = {}) {
        this.id = entry.id;
        this.name = entry.name;
        this.data = entry.data;
        this.extension = entry.extension;
        this.path = entry.path;
        this.url = entry.data ? this.computeImageUrl(entry.data) : null;
    }

    computeImageUrl(data) {
        const blob = AppUtils.buildBlobFromDataString(data);
        return URL.createObjectURL(blob);
    }
}
